import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

const TwoColImageText = ({ textLeft, imageUrl, children }) => {
  let textClass = ''
  if (textLeft) {
    textClass = 'flex-order--1'
  }

  return (
    <div className="column is-10 is-offset-1">
      <div className="columns">
        <div className="column">
          <img className="full-w" src={imageUrl} alt=""></img>
          {/* <Img className="full-w" fluid={imageUrl.childImageSharp.fluid} alt=""/> */}
        </div>

        <div className={textClass + ' column align-self-center'}>
          {children}
        </div>
      </div>
    </div>
  )
}

TwoColImageText.defaultProps = {
  textLeft: false,
}

TwoColImageText.propTypes = {
  textLeft: PropTypes.bool,
  imageUrl: PropTypes.string,
  children: PropTypes.node,
}

export default TwoColImageText
